import Vue from "vue";
import App from "./App";
import router from "./router";
import promise from "babel-polyfill";
import Vant from "vant";
import "vant/lib/index.css";
import "@vant/touch-emulator";
import finger from "vue-finger-directive";
import VueAwesomeSwiper from "vue-awesome-swiper";
// import 'swiper/swiper-bundle.css'
import "@/util/font-rem.js";
import { toHomePage } from "./util/common";
// import style (<= Swiper 5.x)
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper /* { default options with global component } */);
//

Vue.use(Vant);
Vue.use(promise);
Vue.use(finger);

Vue.directive("real-img", function(url) {
  return new Promise(resolve => {
    var img = new Image();
    img.onload = function() {
      resolve(true);
      img = null;
    };
    img.onerror = function() {
      resolve(false);
      img = null;
    };
    img.src = url;
  });
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

Vue.config.ignoredElements = ["wx-open-launch-weapp"];
Vue.prototype.$toHomePage = toHomePage;
new Vue({
  el: "#app",
  router,
  // store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js